import TabPanel from "../TabPanel";
import { SettingsModalTabProps } from "../types";
import UserManagement from "./UserManagement";

const UserManagementTab: React.FC<SettingsModalTabProps> = ({ parentTab, index }) => {
  return (
    <TabPanel value={parentTab} index={index} paddingX={1} height={"calc(100vh - 110px)"}>
      <UserManagement />
    </TabPanel>
  )
}
export default UserManagementTab;
